{
    "faq": {
        "title": "Preguntas frecuentes",
        "faqs": [
          {
            "question": "¿Puedo usar MAJORITY si no soy un migrante?",
            "answer": "¡Sí! Todos son bienvenidos. Si alguna de las funciones de nuestra app te interesa, regístrate y pruébala."
          },
          {
            "question": "¿Es MAJORITY un banco?",
            "answer": "Somos una app de membresía financiera y Axiom Bank, N.A., miembro de la FDIC, brinda nuestros servicios financieros. Axiom Bank, N.A., también emite nuestra Tarjeta de débito MAJORITY Visa® conforme a una licencia de Visa U.S.A. Inc. ¡La tarjeta se puede utilizar en cualquier lugar donde se acepte Visa!"
          },
          {
            "question": "¿Qué es MAJORITY?",
            "answer": "MAJORITY es la primera membresía financiera desarrollada por migrantes, para migrantes. Después de registrarte, ¡recibes una cuenta asegurada por la FDIC sin cargos por sobregiro, una Tarjeta de Débito Visa®, envíos de dinero sin cargos, llamadas internacionales gratuitas y baratas, y más!"
          },
          {
            "question": "¿Dónde está MAJORITY?",
            "answer": "Tenemos oficinas en Houston, Miami y Estocolmo, Suecia. Visítanos en nuestro lugar de encuentro MAJORITY Meetup Houston, ubicado en 9801 V Bissonnet Street, Houston, Texas 77036, Estados Unidos."
          },
          {
            "question": "¿Estará seguro mi dinero con MAJORITY?",
            "answer": "Absolutamente. Tu cuenta MAJORITY está asegurada por la FDIC, así que no importa si estás en EE.UU. o en el extranjero, el dinero en tu cuenta está asegurado por la FDIC hasta por $250,000. Además, podrás acceder a la app desde cualquier parte del mundo, así que ¡no tienes de qué preocuparte."
          }
        ]
      }
}